<template>
    <span>
        <span v-if="value">
            <a :href="numberLink">{{value}}</a>
        </span>
        <span v-else>N/A</span>
    </span>
</template>
<script>
    export default{
        name: 'phone-number',
        props: {
            value: {
                type: [Boolean, String],
                description: 'Phone Number',
                default: false
            }
        },
        computed: {
            numberLink () {
                return `tel:${this.value}`
            }
        }
    }
</script>
